import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=166b81ee&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=ts&"
export * from "./Files.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b81ee",
  null
  
)

export default component.exports